import { useIntl } from 'react-intl';
import { useCallback } from 'react';

export const useFormatBytes = () => {
  const { formatMessage } = useIntl();

  const formatBytes = (bytes?: number): string => {
    if (!bytes && bytes !== 0) {
      return '';
    }

    const asMegabytes = bytes / 1000 ** 2;

    const asGigaBytes = asMegabytes / 1000;
    return asMegabytes > 1000
      ? formatMessage({ id: 'Storage.Media_Size_Label.GB' }, { amount: asGigaBytes.toFixed(1) })
      : formatMessage({ id: 'Storage.Media_Size_Label.MB' }, { amount: asMegabytes.toFixed(0) });
  };

  return useCallback(formatBytes, [formatMessage]);
};

export const useFormattedBytes = (bytes?: number): string => useFormatBytes()(bytes);
